import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";

const AdminNav = () => {
	const navigate = useNavigate();
	const [menuOpen, setMenuOpen] = useState(false);

	const logout = () => {
		localStorage.removeItem("nguser");
		navigate("/");
	};

	const navLinks = [
		{ name: "All Exercises", path: "/showexercise" },
		{ name: "All Sessions", path: "/admin/showsession" },
		{ name: "Register Coach", path: "/admin/registercoach" },
	];

	return (
		<nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-white/10 border-b border-white/20 text-white">
			<div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
			<div className="h-12">
					<img src="/full_logo.png" className="h-full" alt="Logo" />
				</div>

				{/* Desktop Nav */}
				<div className="hidden md:flex space-x-6 items-center text-base font-medium">
					{navLinks.map((link) => (
						<div
							key={link.name}
							onClick={() => navigate(link.path)}
							className="cursor-pointer hover:text-orange-400 transition"
						>
							{link.name}
						</div>
					))}
					<div
						onClick={logout}
						className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-full cursor-pointer transition"
					>
						Logout
					</div>
				</div>

				{/* Mobile Toggle */}
				<div className="md:hidden">
					<button onClick={() => setMenuOpen(!menuOpen)}>
						{menuOpen ? (
							<FiX className="w-6 h-6" />
						) : (
							<FiMenu className="w-6 h-6" />
						)}
					</button>
				</div>
			</div>

			{/* Mobile Dropdown */}
			<div
				className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
					menuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
				} px-6 bg-black/90 backdrop-blur-md border-t border-white/20`}
			>
				<div className="flex flex-col space-y-4 py-4 text-base font-medium">
					{navLinks.map((link) => (
						<div
							key={link.name}
							onClick={() => {
								navigate(link.path);
								setMenuOpen(false);
							}}
							className="cursor-pointer hover:text-orange-400 transition"
						>
							{link.name}
						</div>
					))}
					<div
						onClick={() => {
							logout();
							setMenuOpen(false);
						}}
						className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-full cursor-pointer transition"
					>
						Logout
					</div>
				</div>
			</div>
		</nav>
	);
};

export default AdminNav;

